import { Component, OnInit, Input } from '@angular/core';

import { ContextTyres } from '../../../_models/tyres/context.tyres';
import { ShoppingCartItem } from '../../../_models/cart/shopping.cart.item';
import { WheelTyreSet } from '../../../_models/rims-and-tyres/wheel.tyre.set';
import { MainService } from '../../../_services/main.service';
import { RimAndTyreService } from '../../../_services/rim-and-tyre.service';
import { CatalogService } from '../../../_services/catalog.service';
import { ShopSoort } from '../../../_models/common/shop.soort';

@Component({
  selector: 'app-tyre-list-item-compact',
  templateUrl: './tyre-list-item-compact.component.html',
  styleUrls: ['./tyre-list-item-compact.component.scss']
})
export class TyreListItemCompactComponent implements OnInit {
  @Input() ctx: ContextTyres;
  @Input() tyre: ShoppingCartItem;
  @Input() set: WheelTyreSet;
  @Input() odd: boolean;
  shopKind = ShopSoort;

  constructor(
    public mainService: MainService,
    public rimAndTyreService: RimAndTyreService,
    public catalogService: CatalogService
  ) { }

  ngOnInit() {
  }
}
